import { Button, Space, Typography } from 'antd'
import { RightOutlined } from '@ant-design/icons'

const { Title } = Typography

interface BlogHeaderProps {
  onPreviewChange?: (showPreview: boolean) => void
  onSave?: () => void
  onEdit?: boolean
  isSaving?: boolean
  onBackToBlog?: () => void
  isFormValid?: boolean
}

const BlogHeader = ({ onPreviewChange, onSave, onEdit, onBackToBlog, isFormValid = false }: BlogHeaderProps) => {
  const handleBlogClick = () => {
    onBackToBlog?.()
  }

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '24px',
      paddingBottom: '16px',
      borderBottom: '1px solid #f0f0f0'
    }}>
      <div>
        <div style={{
          fontSize: '14px',
          color: '#666',
          marginBottom: '8px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <span 
            style={{ 
              cursor: 'pointer', 
              textDecoration: 'none'
            }}
            onClick={handleBlogClick}
          >
            Blog
          </span>
          <RightOutlined /> {onEdit ? "Edit blog post" : "New blog post"}
        </div>

        <Title level={2} style={{ margin: 0, fontWeight: '600' }}>
          {onEdit ? "Edit" : "New"}
        </Title>
      </div>

      <Space>
        <Button
          style={{
            width: '109px',
            height: '37px',
            fontSize: '14px',
            fontWeight: '600',
            borderRadius: '8px',
            border: "1px solid #2BA7CA",
            color: isFormValid ? "#2BA7CA" : "#ccc"
          }}
          disabled={!isFormValid }
          onClick={() => isFormValid && onPreviewChange?.(true)}
        >
          Preview
        </Button>

        <Button
          type="primary"
          style={{
            width: '84px',
            height: '37px',
            fontSize: '14px',
            fontWeight: '600',
            borderRadius: '8px',
            backgroundColor: '#2BA7CA'
          }}
          onClick={onSave}
        >
          {onEdit ? "Update" : "Save"}
        </Button>
      </Space>
    </div>
  )
}

export default BlogHeader
